import me from "../assets/images/me.png"

function Footer() {
    return (
        <div class="footer">
            <a
                title="its just me"
                target="_blank"
                href="https://github.com/LatifY"
                class="footer-credit"
            >
                <img
                    draggable="false"
                    class="footer-credit-image"
                    src={me}
                    alt="madeline"
                />
                <div class="footer-credit-text">
                    <span class="footer-credit-text-name">Latif Yılmaz</span>
                    <br />
                    <span class="footer-credit-text-description">
                        Developer
                    </span>
                </div>
            </a>
            <div class="footer-copyright">
                Ⓒ 2021{" "}
                <span class="footer-lative">
                    lative
                </span>{" "}
                /<span class="footer-rights">All rights reserved.</span>
            </div>
        </div>
    );
}

export default Footer;
